import { render, staticRenderFns } from "./qlBtn.vue?vue&type=template&id=6e30a675&scoped=true"
import script from "./qlBtn.vue?vue&type=script&lang=js"
export * from "./qlBtn.vue?vue&type=script&lang=js"
import style0 from "./qlBtn.vue?vue&type=style&index=0&id=6e30a675&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e30a675",
  null
  
)

export default component.exports